export default __webpack_public_path__ + "img/rank2tab-82475648.png";